// extracted by mini-css-extract-plugin
export default {"container":"Description_container__OWKsC","description":"Description_description__1e29f"};